export const CURRENT_VERSION = '1.1.0';
export const SAVED_STORE_KEY = 'my-app';